import { render, staticRenderFns } from "./FilterGroup.vue?vue&type=template&id=dffdc920"
import script from "./FilterGroup.vue?vue&type=script&lang=js"
export * from "./FilterGroup.vue?vue&type=script&lang=js"
import style0 from "./FilterGroup.vue?vue&type=style&index=0&id=dffdc920&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports